import type { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useProfile } from "@/auth/useProfile";
import { LinkGen } from "@/LinkGen";

export const SubscriptionRoutes: FC = () => {
  const { profile } = useProfile();

  if (!profile.subscription) {
    return <Navigate to={LinkGen.Subscription()} />;
  }

  return <Outlet />;
};
